export function addUrlProtocol(url, https = false) {
  if (!url) return url
  if (url.indexOf('http') === 0) return url

  return `http${https ? 's' : ''}://${url}`
}
